import { PaceEnvironment } from '@evorait/pace-environment';

export const environment: PaceEnvironment = {
    production: false,
    operateInMockMode: false,
    appId: 'com.siemens.medical.solutions.usa.paceFormsForAuthors',
    apiBase: 'https://pace-non-prod-backend-qng101-partners.azurewebsites.net',
    apiSapProxy: 'api/proxy',
    reportIssueSupportEmail: 'healthcaretest@service-now.com',
    bundleIdentifierName: 'PACE forms for authors',
    subscriptionServerPublicKey:
        'BGXPTVy72unf7at8QszwD9YXjraFD5JEIS5lpi4q8T46hSTCcZy2fOrfrKBn2kPt4QvlQ28fk2LEAzbyTo3TAPQ',
    msal: {
        fxAppScope: 'api://00ba6061-87f2-48d8-954d-18aa8003f88e/user_impersonation',
        btpApimScope: 'api://20a1d762-b6cc-4fb8-a343-04087124cc93/read',
        graphApiUrl: 'https://graph.microsoft.com/v1.0/me',
        clientId: '406b858f-fead-4e6c-8390-631f25df3125',
        authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
    },
};
